__turbopack_context__.v({
  "actions": "header-module__3iWRfG__actions",
  "bar": "header-module__3iWRfG__bar",
  "brand": "header-module__3iWRfG__brand",
  "container": "header-module__3iWRfG__container",
  "desktopNav": "header-module__3iWRfG__desktopNav",
  "header": "header-module__3iWRfG__header",
  "hidden": "header-module__3iWRfG__hidden",
  "login": "header-module__3iWRfG__login",
  "menuButton": "header-module__3iWRfG__menuButton",
  "mobileAccount": "header-module__3iWRfG__mobileAccount",
  "mobileLink": "header-module__3iWRfG__mobileLink",
  "mobileNav": "header-module__3iWRfG__mobileNav",
  "navLink": "header-module__3iWRfG__navLink",
  "panel": "header-module__3iWRfG__panel",
  "signup": "header-module__3iWRfG__signup",
  "transition": "header-module__3iWRfG__transition",
  "visible": "header-module__3iWRfG__visible",
});
